<div class="smooth-scrolling">
    <section class="about-content-section">
        <div class="container">
            <div class="mx-1010">
                <div class="abt-content">
                    <h4>At <b>ecommerce we believe</b> that each <b>individual’s skin is unique, so why go</b> with the
                        <b>flow?</b></h4>
                </div>
            </div>
        </div>
    </section>

    <section class="abt-image">
        <span>
            <img src="assets/images/about-image.png" alt="image" />
        </span>
    </section>

    <section class="abt-text">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="abt-content-text">
                        <span>Skincare…</span>
                        <strong>simplified</strong>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="abt-paragraph">
                        <p>ecommerce is a hyper-personalised Smart Beauty and Personal Care e-commerce platform with the
                            vision of revolutionising the BPC industry with immersive experiences and innovative
                            solutions. Our AI-backed skin tests, hair tests, AR guided virtual try-on experiences, AI
                            foundation finder and personalised consultations with experienced dermatologists combine to
                            create a purely hyper-personalised shopping experience. We aim to empower you with
                            personalised product, routine and content recommendations, ensuring that you find the best
                            fit for all your beauty and personal care needs.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="abt-content-slider-section d-lg-block d-none">
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    CRUELTY-FREE
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    safe & effective skincare
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Authentic products
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    VEGAN Quality
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Ingredients
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    CRUELTY-FREE
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    safe & effective skincare
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Authentic products
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    VEGAN Quality
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Ingredients
                </div>
            </ng-template>
        </owl-carousel-o>
    </section>


    <section class="trust-section">
        <div class="t-title">
            <h4 class="text-end">Trust</h4>
            <h4>because <span>US</span></h4>
        </div>
        <div class="trust-content">
            <div class="t-image">
                <span class="t-center-image"><img src="assets/images/trust-image.png" alt="image" /></span>
                <div class="t-image-content-box-one">
                    <h5>We Are Expert-Driven</h5>
                    <p>Our in-house experts guide and provide you with suitable ingredients, products, and routines. The
                        products we sell are carefully curated by these experts and are result-oriented.</p>
                </div>
                <div class="t-image-content-box-two">
                    <h5>We Put Your Needs First</h5>
                    <p>ecommerce is all about providing simplified solutions that suit your needs, concerns, and fit within
                        your budget.</p>
                </div>
                <div class="t-image-content-bottom-box">
                    <div class="t-image-content-box-three">
                        <h5>we don’t follow trends</h5>
                        <p>We won't blindly rope you into purchasing 'what's hot right now'. It’s your call, with the
                            help of our experts of course.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="abt-content-slider-section d-lg-none d-block">
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    CRUELTY-FREE
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    safe & effective skincare
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Authentic products
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    VEGAN Quality
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Ingredients
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    CRUELTY-FREE
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    safe & effective skincare
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Authentic products
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    VEGAN Quality
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="abt-slide-content">
                    Ingredients
                </div>
            </ng-template>
        </owl-carousel-o>
    </section>
</div>
<!-- Footer START -->
<app-footer-bg></app-footer-bg>
<!-- Footer END -->